import { render, staticRenderFns } from "./login_third.vue?vue&type=template&id=0ab2d990&scoped=true"
import script from "./login_third.vue?vue&type=script&lang=js"
export * from "./login_third.vue?vue&type=script&lang=js"
import style0 from "./login_third.vue?vue&type=style&index=0&id=0ab2d990&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab2d990",
  null
  
)

export default component.exports